function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import Icon from '../Icon.js';
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.8 8h14.4M4.8 12l-4-4 4-4",
    stroke: "var(--icon-color)",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var IconArrowLeft = function IconArrowLeft(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    icon: SvgArrowLeft
  }, props));
};
export default IconArrowLeft;